/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';

/**
 * 
 * @export
 * @interface InboundDocumentActivityEntry
 */
export interface InboundDocumentActivityEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    actor?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
    /**
     * Discriminated on action: RECEIVED, READ, FOLDER_CHANGED, WORK_STATUS_CHANGED, FACILITIES_CHANGED, LEAD_LINKED, LEAD_UNLINKED, SENT_TO_SCREENER, SPLIT
     */
    details: { [key: string]: any; };
    /**
     * 
     */
    date_created: Date;
}

/**
 * Check if a given object implements the InboundDocumentActivityEntry interface.
 */
export function instanceOfInboundDocumentActivityEntry(value: object): value is InboundDocumentActivityEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function InboundDocumentActivityEntryFromJSON(json: any): InboundDocumentActivityEntry {
    return InboundDocumentActivityEntryFromJSONTyped(json, false);
}

export function InboundDocumentActivityEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentActivityEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'actor': json['actor'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['actor']),
        'details': json['details'],
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
    };
}

export function InboundDocumentActivityEntryToJSON(json: any): InboundDocumentActivityEntry {
    return InboundDocumentActivityEntryToJSONTyped(json, false);
}

export function InboundDocumentActivityEntryToJSONTyped(value?: InboundDocumentActivityEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'actor': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value['actor']),
        'details': value['details'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
    };
}

